import { render, staticRenderFns } from "./roleAddUser.vue?vue&type=template&id=6b9d8cac"
import script from "./roleAddUser.vue?vue&type=script&lang=js"
export * from "./roleAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports